import { useEffect } from 'react';

function Modal({ title, children, onClose }) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-gray-950/50 px-4 py-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="dashboard-modal-title"
    >
      <button
        type="button"
        className="absolute inset-0 h-full w-full cursor-default"
        aria-label="Close modal"
        onClick={onClose}
      />
      <section className="relative flex max-h-[85vh] w-full max-w-3xl flex-col rounded-lg border border-gray-200 bg-white shadow-xl">
        <header className="flex items-center justify-between gap-4 border-b border-gray-200 px-5 py-4">
          <h2 id="dashboard-modal-title" className="text-xl font-bold text-gray-950">
            {title}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-800 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Close
          </button>
        </header>
        <div className="overflow-y-auto p-5">
          {children}
        </div>
      </section>
    </div>
  );
}

export default Modal;
